

export const Styles =() =>({
postCard: {position: 'relative', borderRadius: '5px', margin: '1px'},
creatorContainer:{display:'flex', justifyContent: 'space-between', padding: '0 0.2rem', position:'absolute',left:'0.1rem', top:'0.2rem', right:'0.05rem', zIndex: 100},
tagsContainer:{color:'black', opacity: 0.5, marginTop:'0.2rem', marginLeft:'0.5rem'},
postActions:{display: 'flex', alignItems: 'center', justifyContent:'space-between'},
postActionModal:{
  display:'flex',
  flexDirection:'column',
  justifyContent:'space-between',
  alignItems:'center',
  position: 'absolute',
  borderRadius:'0.5rem',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '300px',
  bgcolor: 'background.paper',
  border: '2px solid blue',
  boxShadow: 24,
  m: 4,
  p:4,
  zIndex: 100

},
postActionButtons:{display: 'flex', justifyContent: 'space-between',gap:'0.75rem', marginTop: '0.5rem', padding:'0 0.5rem'}
})